"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Head = void 0;
var React = require("react");
var ReactDOM = require("react-dom");
var recompose_1 = require("recompose");
var classNames = require("classnames");
var left = 0;
var ticking = false;
var lastScrollTop = 0;
var lastScrollBottom = 0;
var scrollListener = function (viewport, header, headerClone) { return function () {
    var offset = lastScrollTop;
    var bottom = lastScrollBottom;
    var headerHeight = header.clientHeight;
    if (offset < headerHeight + 4 && bottom > headerHeight * 1.5) {
        if (headerClone.style.visibility === 'hidden') {
            headerClone.style.visibility = 'visible';
        }
    }
    else {
        if (headerClone.style.visibility === 'visible') {
            headerClone.style.visibility = 'hidden';
        }
    }
    ticking = false;
}; };
var requestTick = function (viewport, header, headerClone) {
    if (!ticking) {
        requestAnimationFrame(scrollListener(viewport, header, headerClone));
        ticking = true;
    }
};
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('Head'), (0, recompose_1.withState)('reference', 'setReference', null), (0, recompose_1.withState)('headerClone', 'setHeaderClone', null), (0, recompose_1.withHandlers)({
    onWheel: function (props) { return function (event) {
        var headerClone = props.headerClone;
        left = event.detail.position;
        headerClone.childNodes[0].style.left = -left + 'px';
    }; },
    onScroll: function (props) { return function (event) {
        var parentToStickTo = props.parentToStickTo, reference = props.reference, headerClone = props.headerClone;
        var overview = parentToStickTo.parentNode.parentNode;
        var rect = overview.getBoundingClientRect();
        lastScrollTop = rect.top;
        lastScrollBottom = rect.bottom;
        requestTick(parentToStickTo, reference, headerClone);
    }; }
}), (0, recompose_1.lifecycle)({
    componentWillReceiveProps: function (nextProps) {
        if (this.props.sticky &&
            !this.props.headerClone &&
            nextProps.headerClone) {
            document.addEventListener('scroll', nextProps.onScroll);
        }
        if (nextProps.scrollbar) {
            if (!this.props.headerClone &&
                nextProps.headerClone &&
                nextProps.sticky) {
                nextProps.scrollbar
                    .querySelectorAll('.scrollbar')[0]
                    .addEventListener('scrollbar:wheel', nextProps.onWheel);
            }
        }
        if (nextProps.sticky &&
            nextProps.reference &&
            nextProps.parentToStickTo &&
            nextProps.width &&
            nextProps.width !== this.props.width) {
            if (nextProps.headerClone) {
                setTimeout(function () {
                    var reference = nextProps.reference, headerClone = nextProps.headerClone, parentToStickTo = nextProps.parentToStickTo;
                    var overview = parentToStickTo.parentNode
                        .parentNode;
                    var table = reference.parentNode;
                    var tr = headerClone.children[0];
                    var children = tr.children;
                    var tds = reference.children[0].children;
                    var leftOffset = parseInt(overview.style.left, 10);
                    var tableWidth = table.clientWidth;
                    var tableLeft = table.getBoundingClientRect().left;
                    // WHAM BAM THANK YOU MA'M
                    for (var i = 0; i < tds.length; i++) {
                        var child = tds[i];
                        var computedStyle = window.getComputedStyle(child);
                        var cloneChild = children[i];
                        cloneChild.style.width =
                            child.clientWidth -
                                (parseFloat(computedStyle.paddingLeft) +
                                    parseFloat(computedStyle.paddingRight)) +
                                'px';
                    }
                    headerClone.style.left = -leftOffset + tableLeft + 'px';
                    headerClone.style.width =
                        overview.parentNode.clientWidth + 'px';
                    tr.style.width = tableWidth + 'px';
                    tr.style.left = leftOffset + 'px';
                }, 66);
            }
        }
    },
    componentWillUnmount: function () {
        if (this.props.sticky) {
            document.removeEventListener('scroll', this.props.onScroll);
        }
        if (this.props.scrollbar) {
            var el = this.props.scrollbar.querySelectorAll('.scrollbar')[0];
            el.removeEventListener('scrollbar:wheel', this.props.onWheel);
        }
    }
}), recompose_1.pure);
exports.Head = enhance(function (_a) {
    var sticky = _a.sticky, setReference = _a.setReference, setHeaderClone = _a.setHeaderClone, children = _a.children, className = _a.className;
    return [
        sticky
            ? ReactDOM.createPortal(React.createElement("div", { key: "portal", ref: setHeaderClone, className: classNames('sok-table-head sticky', className), style: { visibility: 'hidden' } }, children), document.body)
            : null,
        React.createElement("thead", { key: "head", ref: setReference, className: classNames('sok-table-head', className) }, children)
    ];
});
//# sourceMappingURL=index.js.map